import { render } from "./MyAccountOverview.vue?vue&type=template&id=8b6d7bba"
import script from "./MyAccountOverview.vue?vue&type=script&lang=js"
export * from "./MyAccountOverview.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__